import { getConfig } from './config'

type ForgotPassword = {
  email: string;
  captcha?: string;
}

type ResetPassword = {
  email: string;
  password: string;
  token: string;
}

export type Subscription = {
  isSubscribed: boolean;
  cancellationEffectiveDate: Date;
}

type ForgotPasswordResponse = {
  success: true;
}

export const askCode = async ({ email, ...restParams }: ForgotPassword): Promise<ForgotPasswordResponse> => {
  const config = getConfig()
  const response = await config.axios.post<ForgotPasswordResponse>(`${config.API_URL}/auth/forgot-password`, {
    email,
    ...restParams
  })

  return response.data
}

export const resetPassword = async ({ email, ...restParams }: ResetPassword): Promise<ForgotPasswordResponse> => {
  const config = getConfig()
  const response = await config.axios.post<ForgotPasswordResponse>(`${config.API_URL}/auth/forgot-password/reset`, {
    email,
    ...restParams
  })

  return response.data
}
